import React, { useState } from 'react';
import { bookingShape, historyShape } from 'constants/propTypes';
import { FormattedMessage, intlShape } from 'react-intl';
import Modal from 'components/ui/Modal';
import { ConfirmButton, ActionButton } from 'components/ui/Button';
import { Row } from '../../../components/shared/Layout';
import { StyledColumn } from '../Journeys/AfterSalesWarning/AfterSalesWarning.styles';
import currencySymbols from '../../../constants/currencies';

const UnderpaidWarningPopup = ({ history: { push }, booking, intl: { formatMessage } }) => {
  const [isOpen, toggleOpen] = useState(true);
  const closeModal = () => toggleOpen(false);

  const redirectToPayments = () => {
    push(`/manage/bookings/${booking.reference}/payment?currency=${booking.currency}`);
    closeModal();
  };

  const getMessaging = () => `
    ${formatMessage(
      { id: 'manageBooking.underpaid.firstSubtitle' },
      { underpaidAmount: `${currencySymbols[booking.currency]}${Math.abs(booking.totalPriceToBePaid)}` }
    )}
    ${formatMessage({ id: 'manageBooking.underpaid.secondSubtitle' })}
    `;

  return (
    <Modal
      isOpen={isOpen}
      title={<FormattedMessage id="bookingDetails.bookingIsUnderpaid" />}
      subtitle={getMessaging()}
      onClose={closeModal}
    >
      <Row>
        <StyledColumn span={4}>
          <ConfirmButton data-cy="pay-or-writeoff" onClick={redirectToPayments}>
            <FormattedMessage id="manageBooking.underpaid.payOrWriteOff" />
          </ConfirmButton>
        </StyledColumn>

        <StyledColumn span={4}>
          <ActionButton type="button" data-cy="underpaid-investigate" onClick={closeModal}>
            <FormattedMessage id="manageBooking.overpaid.investigate" />
          </ActionButton>
        </StyledColumn>
      </Row>
    </Modal>
  );
};

UnderpaidWarningPopup.propTypes = {
  booking: bookingShape,
  history: historyShape,
  intl: intlShape
};

export default UnderpaidWarningPopup;
